module.exports = __webpack_public_path__ + "media/images/Pin plusieurs-4ca7203ab38798ad2d5dbe23abc0bf13.svg";